import { AxiosResponse, isAxiosError } from 'axios';
import createAxiosInstance from '../middlewares/axios.interceptors';

const timesheetUrl = '/espelho-ponto';

export const TimeSheetService = {
  getTimeSheetList: async () => {
    const axiosInstance = createAxiosInstance();
    try {
      return await axiosInstance.get(timesheetUrl + '/list');
    } catch (err: unknown) {
      if (isAxiosError(err)) {
        throw err.response as AxiosResponse;
      }
    }
  },

  getTimeSheetDetails: async (data: string) => {
    const axiosInstance = createAxiosInstance();
    try {
      return await axiosInstance.get(timesheetUrl + '/retorna-espelho-ponto', {
        params: {
          data: data
        }
      });
    } catch (err: unknown) {
      if (isAxiosError(err)) {
        throw err.response as AxiosResponse;
      }
    }
  }
};
